import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import { skeletonBusyProps, skeletonRoundedSx } from './skeletonCommon'

interface Props {
  readonly testId?: string
}

export function RewardBalanceCardSkeleton({
  testId = 'rewards-balance-card-skeleton',
}: Readonly<Props>) {
  return (
    <Box
      data-testid={testId}
      {...skeletonBusyProps}
      aria-label="Loading balance"
      sx={{
        border: '1px solid #bdceff',
        bgcolor: 'rgba(189,206,255,0.3)',
        borderRadius: '12px',
        p: '25px',
        minHeight: '121px',
        mb: '32px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="rounded" width="75%" height={40} sx={{ ...skeletonRoundedSx, maxWidth: 360 }} />
        <Skeleton variant="rounded" width={180} height={20} sx={{ borderRadius: '6px', mt: '6px' }} />
      </Box>
      <Skeleton
        variant="rounded"
        width={100}
        height={100}
        sx={{ ...skeletonRoundedSx, flexShrink: 0, display: { xs: 'none', sm: 'block' } }}
      />
    </Box>
  )
}
